import { connect } from 'react-redux';
import ReportMonthlyFinanceComponent from './monthly-finance.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {
		intl: null,
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportMonthlyFinanceComponent);



// WEBPACK FOOTER //
// ./src/components/report/monthly-finance/monthly-finance.ts